import { _ as GridRender } from "gridjs-react";
import DataGrid from "../../components/admin/DataGrid";
import ActionDropDown from "../../components/admin/ActionDropDown";
import { useNavigate, useParams } from "react-router-dom";
import { PAGE } from "../../constants/page";
import { ActionListAdmin, TestDataAdminList } from "../../mock/admin/AdminHome";

const Admin = () => {
  const navigate = useNavigate();
  const { state } = useParams();
  const handlActionClick = (rowData: any, actionValue: any) => {
    console.log("am here===", rowData, actionValue);
    if (actionValue === "viewDetails") {
      const routeLink = PAGE.GLOBAL_STATE_ADMIN.replace(
        ":state",
        rowData?._cells[0].data
      ).concat("/admin");
      navigate(routeLink);
    }
  };

  const TestColumn: any[] = [
    {
      id: "stateName",
      name: "State Name",
      sort: { enabled: true },
    },
    { id: "totalDistricts", name: "Total Districts", sort: { enabled: true } },
    {
      id: "totalStateAdmin",
      name: "Total State Admin",
      sort: { enabled: true },
      width: "20%",
    },
    { id: "totalAsha", name: "Total ASHA", sort: { enabled: true } },
    { id: "totalPatient", name: "Total Patients", sort: { enabled: true } },
    {
      id: "actions",
      name: "Action",
      formatter: (_cell: any, row: any) => {
        return GridRender(
          <ActionDropDown
            actionList={ActionListAdmin}
            row={row}
            onActionClick={handlActionClick}
          />
        );
      },
    },
  ];

  return (
    <>
      <div className="bg-light-gray">
        <div className="container">
          <h2>Welcome Test User </h2>
        </div>
      </div>
      <div className="container">
        <div className="mb-4">
          <h2>List of States</h2>
        </div>
        <DataGrid
          columnData={TestColumn}
          cellData={TestDataAdminList}
          // paginationSever={paginationServer}
          // serverConfig={serverConfig}
        />
      </div>
    </>
  );
};

export default Admin;
